export const homepageFaq = [
  {
    q: "Vad kostar en herrklippning hos Tailor's Barber?",
    a: "En herrklippning kostar 450 kr. Taper fade och skin fade kostar också 450 kr. Kombination herrklippning + skäggtrimning kostar 680 kr.",
  },
  {
    q: "Hur bokar jag tid?",
    a: "Boka online via BokaDirekt. Du kan välja salong, barberare och tid. Drop-in är välkommet i mån av tid.",
  },
  {
    q: "Var finns Tailor's Barber i Stockholm?",
    a: "Vi har fyra salonger: Åhléns City (centrala Stockholm), Täby Centrum, Åkersberga (ICA Maxi) och Arninge (ICA Maxi, Täby).",
  },
  {
    q: "Är ni öppna på helger?",
    a: "Ja, alla salonger har öppet lördag och söndag. Se respektive salongs öppettider för exakta tider.",
  },
  {
    q: "Gör ni taper fade och skin fade?",
    a: "Ja, fade-klippning är en av våra specialiteter. Vi erbjuder taper fade, skin fade, bald fade, drop fade, low fade, mid fade och high fade.",
  },
  {
    q: "Klipper ni barn?",
    a: "Ja. Barnklippning för barn upp till 10 år kostar 380 kr.",
  },
  {
    q: "Kan man komma utan bokning?",
    a: "Ja, drop-in är välkommet i mån av tid. För att garantera tid rekommenderar vi onlinebokning, speciellt på helger.",
  },
  {
    q: "Säljer ni hårvårdsprodukter?",
    a: "Ja, vi säljer ett urval av professionella herrgrooming-produkter i alla våra salonger.",
  },
];
